import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Api from './http.js'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import gloablConfig from './config.js'
import VCharts from 'v-charts'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
// 引入Echarts
import echarts from "echarts"
import BaiduMap from 'vue-baidu-map'
import moment from "moment"
import Print from 'vue-print-nb'

Vue.config.productionTip = false;
//使用
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment;
Vue.prototype.Api = Api;
Vue.prototype.Config = gloablConfig;
Vue.use(BaiduMap,{
	ak:'GpCMY8pL6DG375p9odEiq3Fo8c51K1EV'
})
Vue.use(Print);
Vue.use(Antd);
Vue.use(VCharts);
Vue.use(VXETable);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
